module.exports = __webpack_public_path__ + "img/product-letter-envelope.f0c5c80f.svg";